// 单位信息即培训机构信息
import { TeachUnitPageDTO } from '@api/gateway/PlatformBasicData'

export class TeachUnit {
  /**
   * 是否展示移动
   */
  mobileShow: boolean
  /**
   * 是否展示微信
   */
  wxShow: boolean
  id: string
  name: string
  /**
   * 组织机构证
   */
  organizationCode: string
  /**
   * 单位省份id
   */
  provinceId: string
  /**
   * 单位地区 市
   */
  cityId: string
  /**
   * 单位地区 区县
   */
  countyId: string
  /**
   * 单位状态 | 1：正常;2:停用  默认正常
   */
  status: string
  /**
   * 门户名称
   */
  portalName: string
  /**
   * logo
   */
  logoUrl = ''
  /**
   * 轮播图
   */
  bannerUrls = new Array<string>()
  /**
   * 页面底部
   */
  portalFooterDescribe = ''
  /**
   * 在线客服
   */
  onlineCustomerInfo = ''
  /**
   * 客服电话
   */
  customerPhone = ''

  static from(dto: TeachUnitPageDTO): TeachUnit {
    const unit = new TeachUnit()
    unit.id = dto.id
    unit.name = dto.name
    unit.organizationCode = dto.organizationCode
    unit.provinceId = dto.provinceId
    unit.cityId = dto.cityId
    unit.countyId = dto.countyId
    unit.status = dto.status
    return unit
  }
}
